import React from 'react'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels';

// All these charts are from charts.js - just extending the library...

const BarChart = (props) => {

  const { years } = props

  // let today = Math.round((years[0] * 12)).toLocaleString(undefined)

  return (
    <div>
      <Bar
        data={{
          labels: ['Today', '5 years', '10 years', '15 years', '20 years', '25 years'],
          datasets: [
            {
              barThickness: 20,
              label: '$',
              font: {
                size: 35
                // family: 'PT Sans, sans-serif'
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                color: 'black',
                formatter: function (value) {
                  return "$" + value;
                },
              },
              data: [
                Math.round(years[0]),
                Math.round(years[4]),
                Math.round(years[9]),
                Math.round(years[14]),
                Math.round(years[19]),
                Math.round(years[24])
              ],
              backgroundColor: [
                'rgba(255, 34, 34, 0.98)',
                'rgba(255, 34, 34, 0.98)',
                'rgba(255, 34, 34, 0.98)',
                'rgba(255, 34, 34, 0.98)',
                'rgba(255, 34, 34, 0.98)',
                'rgba(255, 34, 34, 0.98)',
              ]
            }
          ]
        }}
        options={{
          tooltips: {
            titleFontSize: 20,
            bodyFontSize: 35,
            displayColors: false
          },
          title: {
            display: true,
            text: '',
            fontSize: 25,
            fontColor: '#000'

          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }, scales: {
            xAxes: [{
              
              ticks: {
                display: false

              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  return '$' + value;
                }
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }]
          }
        }} height={160}

      />
    </div>
  )

}




export default BarChart
